import styled from 'styled-components';
import { CommonConstant } from '../utility/constants';
import { SemanticImageWithFallback } from './FallbackImage';
import { MuteText } from '../elements';
import type { SemanticSIZES } from 'semantic-ui-react';

interface ItemImageProps {
  disabled?: boolean;
  item: any; // Replace 'any' with your specific item type if available
  size?: SemanticSIZES;
  imageKey?: string;
  extraClasses?: string;
  isMobile?: boolean;
  noMargin?: boolean;
  displayImageKey?: string;
}

interface ProductRowProps {
  products: any[]; // Replace 'any' with your specific product type if available
  containerClass?: string;
  showDetail?: boolean;
  imageKey?: string;
  displayImageKey?: string;
}

// Styled component for CustomImage
export const CustomImage = styled(SemanticImageWithFallback)`
  position: static !important;
  aspect-ratio: 1/1;
  object-fit: contain;
  border-radius: 5px;
`;

// Helper function to get image URL
const getImage = (
  product: any,
  imageKey: string,
  displayImageKey: string = 'displayImage',
): string => {
  if (
    product &&
    Object.prototype.hasOwnProperty.call(product, imageKey) &&
    product?.[imageKey]?.[displayImageKey]
  ) {
    return product[imageKey][displayImageKey];
  }
  return CommonConstant.defaultImage;
};

export function ItemImage({
  disabled,
  item,
  size,
  imageKey = 'pImages',
  extraClasses,
  isMobile,
  noMargin = false,
  displayImageKey,
}: ItemImageProps) {
  const src = getImage(item, imageKey, displayImageKey);

  return (
    <div className={noMargin ? '' : 'd-flex align-items-center'}>
      <CustomImage
        disabled={disabled}
        className={[
          extraClasses,
          isMobile ? 'mobile-img' : '',
          src === CommonConstant.defaultImage ? 'no-image' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        src={src}
        size={size || 'tiny'}
      />
    </div>
  );
}

interface SimpleItemImageProps {
  disabled?: boolean;
  src: string;
  size?: SemanticSIZES;
  extraClasses?: string;
  isMobile?: boolean;
}

export function SimpleItemImage({
  disabled,
  src,
  size,
  extraClasses,
  isMobile,
}: SimpleItemImageProps) {
  return (
    <CustomImage
      disabled={disabled}
      className={[
        extraClasses,
        isMobile ? 'mobile-img' : '',
        src === CommonConstant.defaultImage ? 'no-image' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      src={src}
      size={size || 'tiny'}
    />
  );
}

const ProductContainer = styled.div`
  display: flex;
  margin-bottom: 1em;
  text-align: left;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  min-height: 80px;
`;

const ItemCount = styled.div`
  position: absolute;
  bottom: 0.5rem;
  width: 90%;
`;

export function ProductRow({
  products,
  containerClass = '',
  showDetail = true,
  imageKey = 'p_images',
  displayImageKey = 'display_image',
}: ProductRowProps) {
  return (
    <>
      <ProductContainer className={containerClass}>
        {products.slice(0, 3).map(item => (
          <div className="mx-2" key={item?._id || item?.price || ''}>
            <ItemImage
              displayImageKey={displayImageKey}
              imageKey={imageKey}
              item={item}
            />
          </div>
        ))}
      </ProductContainer>
      {showDetail && products.length > 3 && (
        <ItemCount className="d-flex">
          <MuteText>{products.length} total items</MuteText>
        </ItemCount>
      )}
    </>
  );
}
